import sharedContainer from './CustomTipSharedContainer';
import PaymentModalCustomTip from '../components/PaymentModalCustomTip';

export default sharedContainer(PaymentModalCustomTip);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/PaymentModalCustomTip.js